import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import clientsReducer from './organization/clientSlice';
import projectsReducer from './organization/projectSlice';
import keywordGroupReducer from './organization/keywordGroupSlice';
import brandGroupReducer from './organization/brandGroupSlice';
import themeSlice from './theme/themeSlice';
import categoryReducer from './organization/categoryGroupSlice';
import organizationReducer from './organization/organizationSlice';

export const reducer = {
  auth: authReducer,
  clients: clientsReducer,
  projects: projectsReducer,
  keywordGroups: keywordGroupReducer,
  categoryGroups: categoryReducer,
  brandGroups: brandGroupReducer,
  theme: themeSlice,
  organization: organizationReducer,
};

export const store = configureStore({
  reducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
